import React from 'react'
import { MsalProvider, useMsal } from '@azure/msal-react'

import { msalInstance } from './MSALConfig'
import useLogin from '../hooks/useLogin'
import { useTranslate } from '@ur-solutions/react-hooks'

const AZURE_BACKEND_CLIENT_ID = import.meta.env.VITE_AZURE_BACKEND_CLIENT_ID

/**
 * Renders a button that allows users to sign in with their Microsoft account using MSAL authentication.
 *
 * When clicked, the button triggers a Microsoft login popup and, upon successful authentication,
 * passes the acquired access token to the application's login handler.
 */
export const SignInWithMicrosoft: React.FC = () => {
  const { instance } = useMsal()

  const { handleMicrosoftLogin, loading } = useLogin({ variant: 'microsoft' })
  const translations = useTranslate({
    buttonText: 'login.sign-in-with-microsoft',
  })

  const handleSignInWithMicrosoft = () => {
    instance
      .loginPopup({
        scopes: [`${AZURE_BACKEND_CLIENT_ID}/.default`],
      })
      .then(response => handleMicrosoftLogin(response.accessToken))
      .catch(e => {
        console.error(e)
      })
  }

  return (
    <button
      onClick={handleSignInWithMicrosoft}
      disabled={loading}
      aria-label={translations.buttonText}
    >
      <img
        src="https://learn.microsoft.com/en-us/entra/identity-platform/media/howto-add-branding-in-apps/ms-symbollockup_signin_light.svg"
        alt=""
        className="cursor-pointer"
      />
    </button>
  )
}

/**
 * Wrapper component to provide Msal context
 */
const Wrapper = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <SignInWithMicrosoft />
    </MsalProvider>
  )
}

export default Wrapper
